import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, MapPin, Coffee, Sparkles, Calendar, Gift, Users, Camera, Heart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sip-schedule-admin/artifacts/vd09zrou_Logo%20-%20Final.png";

const navLinks = [
  { to: '/schedule', label: 'Find Us', icon: MapPin },
  { to: '/menu', label: 'Menu', icon: Coffee },
  { to: '/seasonal', label: 'Seasonal', icon: Sparkles },
  { to: '/events', label: 'Private Events', icon: Calendar },
  { to: '/rewards', label: 'Rewards', icon: Gift },
  { to: '/community', label: 'Community', icon: Heart },
  { to: '/about', label: 'About', icon: Users },
  { to: '/gallery', label: 'Gallery', icon: Camera },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-32">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center"
            data-testid="navbar-logo"
          >
            <img 
              src={LOGO_URL} 
              alt="Sip Fantasia" 
              className="h-28 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link px-4 py-2 font-medium text-sm transition-colors
                  ${location.pathname === link.to 
                    ? 'text-sip-purple' 
                    : 'text-gray-700 hover:text-sip-purple'
                  }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-xl bg-gray-100 hover:bg-sip-cyan/20 transition-colors"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} className="text-sip-purple" /> : <Menu size={24} className="text-sip-purple" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-gray-100 overflow-hidden"
            data-testid="mobile-menu"
          >
            <div className="px-4 py-6 space-y-2">
              {navLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setIsOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 font-medium text-lg rounded-xl transition-all
                      ${location.pathname === link.to 
                        ? 'bg-sip-purple text-white' 
                        : 'text-gray-700 hover:bg-sip-cyan/20'
                      }`}
                    data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
                  >
                    <Icon size={20} />
                    {link.label}
                  </Link>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
